define('models/merchants/merchantgroups/merchantgroup_collection',['backbone',
    'models/merchants/merchantgroups/merchantgroup',
], function (Backbone, MerchantGroup) {
    return Backbone.Collection.extend({
        url: function () {
            if (this.instanceURL)
                return this.instanceURL;
            if (this.PageNumber > 0)
                return pf.merchantsURL + "/Groups/" + this.PageNumber;
            else
                return pf.merchantsURL + "/Groups/" + 0;
        },
        defaults:{
            PageNumber: 0
        },
        model: MerchantGroup,
        initialize: function (options) {

            options || (options = {});
            this.instanceURL = options.instanceURL;
            this.PageNumber = options.PageNumber;

        }
    });
});

